import React, { Component } from 'react'
import LoaderButton from '../../components/LoaderButton'
import { checkTranslation, imageAddress, translate } from "../../utils/useful";
import Responsive from '../../components/Responsive';
import SwitchInput from '../../components/inputs/SwitchInput';
import SidebarView from '../../components/SidebarView';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import ActionButton from '../../components/partials/ActionButton';
import { databasePermissions, messengerPermissions, taskPermissions } from '../../variables/permissionsObject';
import SearchUsersFixedView from './SearchUsersFixedView';
import FixedView from '../../components/FixedView';
import SearchGroupsFixedView from './SearchGroupsFixedView';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
import CAHeader from '../../components/header/CAHeader';

class CAPermissions extends Component {

    state = {
        actions: {
            edit: { key: "edit", label: "{{lang}}ca.Edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            remove: { key: "remove", label: "{{lang}}ca.Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
        },
        filterApplet: {
            Database: true,
            Commerce: true,
        },
        admins: [],
        permissionsObject: {},
        data: {},
        searchTab: 'users',
        search: '',
    }

    componentDidMount() {
        this.getPermissions()
        this.setInitData()
        if (this.setHeader) {
            this.setHeader({
                'toolbar': null,
                'showToolbar': false,
                // 'title': `${this.props.user?.info?.fullname}`,
                'info': 'Manage Access',
                topHeaderComponent: this.topHeaderComponent,
                backAction: () => this.props.lastStage()

            })
        }

    }

    setInitData = () => {
        let me = this.props.user?.info
        let admins
        let owner
        if (this.props.initData?.permissions) {
            admins = this.props.initData?.permissions?.admins
        } else {
            admins = [{ mainAccess: true, hub: { _id: me?._id, image: me?.image, fullname: me?.fullname, username: me?.username, type: 'user', owner: true }, permissions: '*' }]
            owner = me?._id
        }
        this.setState({ admins, owner }, () => {
        })
    }

    getPermissions = () => {
        // permissions
        let permissionsObject = {}
        for (let i = 0; i < this.props.initData?.features?.length; i++) {
            switch (this.props.initData.features[i]) {
                case 'Messenger':
                    permissionsObject = messengerPermissions
                    break;
                case 'Database':
                    permissionsObject = databasePermissions
                    break;
                case 'Tasking':
                    permissionsObject = taskPermissions
                    break;
                default:
                    break;
            }
        }
        this.setState({ permissionsObject })
    }

    nextStage = () => {
        let data = {
            admins: this.state.admins,
        }
        if (data) {
            this.props.setData({ permissions: data }, () => {
                this.props.changeStage('userPrespective')
            })
        }
    }

    changeValue = (key, value) => {
        this.setState({ [key]: value }, () => { })
    }

    openEditFieldsSide = () => {
        // this.editFieldsSidebarView.open()
    }

    onNewUsersSelected = (searchType, users, type, cb) => {
        let admins = this.state.admins
        let list = admins
        let currentItemIndex = this.state.currentItemIndex
        users.type = type
        list.push({ [type]: users, permissions: '*' })
        currentItemIndex = list.length - 1
        let item = list[currentItemIndex]
        admins = list
        this.setState({ admins }, () => {
            // this.openPermissions(item, currentItemIndex)
        })
        if (searchType == 'users') {
            this.searchUsersFixedView.hideView()
        }
        if (searchType == 'groups') {
            this.searchGroupsFixedView.hideView()
        }
        cb()
    }

    removePermission = (item, index, key) => {
        if (!item.mainAccess) {
            let list = this.state.admins
            list.splice(index, 1)
            this.setState({ admins: list }, () => { })
        } else {
            this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.canNotChange', description: translate("The list which includes the owner can not be removed") })
        }
    }

    openPermissions = (item, index, key) => {
        if (index != null) {
            let listHasOwner = false
            if (item?.hub) {
                if (item.hub.owner == true) {
                    listHasOwner = true
                }
            }
            this.setState({ isMainAccess: item?.mainAccess, currentItem: item, listHasOwner, currentItemIndex: index }, () => {
                this.sidebarView.open()
            })
        }
    }

    showPermissionsText = (permissions) => {
        let text = ''
        if (permissions == '*') {
            text = translate("Full Access")
        } else {
            text = Object.values(permissions).length + translate(' Permissions')
            if (Object.values(permissions).length == 0) {
                text = translate("No Permissions, Will be removed")
            }
        }
        return text
    }

    infoView(user, index) {
        return (
            <div className='flexc py-1'>
                <div className='mx-2 flexcc'>
                    {user.type == 'group' ? (
                        <img className='task-check-img' src={'/images/icons/comunities.png'} height={26} width={26} style={{ borderRadius: 20 }} />
                    ) : (
                        <img className='task-check-img' src={imageAddress(user?.image, 'profile')} height={26} width={26} style={{ borderRadius: 20 }} />
                    )}
                </div>
                <div className='flexc flex-1'>
                    <p className='task-title  text-small color-gray-3 cursor-pointer'>{user.fullname ?? user.name}</p>
                    {user.owner && (
                        <div className='mld-2 flexcc px-2 py-1' style={{ backgroundColor: '#eee', borderRadius: 20 }}>
                            <p className='text-smaller color-gray-1'>{translate('ca.Owner')}</p>
                        </div>
                    )}
                </div>
            </div>
        )
    }

    permissionInfoView(user, type, index) {
        return (
            <div className='flexcb mb-1 pb-1' style={{ borderBottom: '1px solid #f6f6f6' }}>
                <div className='flexc'>
                    <div className='mld-2 mrd-3 flexcc'>
                        {user?.type && user?.type == 'group' ? (
                            <img className='task-check-img' src={'/images/icons/comunities.png'} height={26} width={26} style={{ borderRadius: 20 }} />
                        ) : (
                            <img className='task-check-img' src={imageAddress(user?.image, 'profile')} height={26} width={26} style={{ borderRadius: 20 }} />
                        )}
                    </div>
                    <div className='d-flex flex-column  flex-1'>
                        <div className='flexc'>
                            <p className='task-title  text-small color-gray-3 '>{user.fullname ?? user.name}</p>
                            {user.owner && (
                                <div className='mld-2 flexcc px-2 py-1' style={{ backgroundColor: '#eee', borderRadius: 20 }}>
                                    <p className='text-smaller color-gray-1'>{translate('ca.Owner')}</p>
                                </div>
                            )}
                        </div>
                        {user.username && (
                            <p className='task-title  text-smaller color-gray-2 '>{user.username}</p>
                        )}
                        {user.type == 'group' && (
                            <p className='task-title  text-smaller color-gray-2 '>{translate('ca.group')}</p>
                        )}
                    </div>
                </div>
                {!user.owner && (
                    <button onClick={() => this.removeUserFromPermission(user, type, index)} className='mx-2  flexcc' style={{ backgroundColor: '#eee', borderRadius: 20, width: 18, height: 18 }}>
                        <img className='opacity-5' src={'/assets/icons/close.svg'} height="14px" />
                    </button>
                )}
            </div>
        )
    }

    changePermission = (key, value, extra) => {
        if (this.state.listHasOwner && this.state.isMainAccess) {
            this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.canNotChange', description: "The list which includes the owner should have full access" })
            return
        }
        let list = this.state.admins
        let admin = list[extra.index]
        let permissions = admin.permissions
        let permissionsObject = this.state.permissionsObject
        if (permissions == '*') {
            permissions = {}
            for (const [skey, svalue] of Object.entries(permissionsObject)) {
                permissions[skey] = '*'
            }
        }
        if (permissions == null) {
            permissions = {}
        }
        if (permissions[extra.sectionKey] == '*') {
            permissions[extra.sectionKey] = {}
            Object.values(permissionsObject[extra.sectionKey].permissions).forEach((element) => {
                if (element.subPermissions) {
                    permissions[extra.sectionKey][element.key] = '*'
                }
                else {
                    permissions[extra.sectionKey][element.key] = true
                }
            })
        }
        if (!permissions[extra.sectionKey]) {
            permissions[extra.sectionKey] = {}
        }
        if (permissions[extra.sectionKey][key] == '*') {
            permissions[extra.sectionKey][key] = {}
            for (let i = 0; i < Object.keys(permissionsObject[extra.sectionKey].permissions[key].subPermissions).length; i++) {
                permissions[extra.sectionKey][key][Object.keys(permissionsObject[extra.sectionKey].permissions[key].subPermissions)[i]] = true
            }
        }
        permissions[extra.sectionKey][key] = value
        if (!permissions[extra.sectionKey][key]) {
            delete permissions[extra.sectionKey][key]
        }
        let fullAccess = true
        if (Object.values(permissionsObject[extra.sectionKey].permissions).length == Object.values(permissions[extra.sectionKey]).length) {
            permissions[extra.sectionKey] = '*'
        }
        Object.values(permissions).forEach((element) => {
            if (element != '*') {
                fullAccess = false
            }
        })
        if ((Object.values(permissions).length == Object.values(this.state.permissionsObject).length && fullAccess)) {
            permissions = '*'
        }
        list[extra.index].permissions = permissions
        let admins = this.state.admins
        admins = list
        this.setState({ admins })
    }

    removeUserFromPermission = (user, type, index) => {
        let admins = this.state.admins
        let list = admins
        list[this.state.currentItemIndex][type].splice(index, 1)
        admins = list
        this.setState({ admins })
    }

    handleCheckBox = (sectionKey, permissionKey, subpermission, adminIndex) => {
        if (this.state.listHasOwner && this.state.isMainAccess) {
            this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.canNotChange', description: "The list which includes the owner should have full access" })
            return
        }
        let admins = this.state.admins
        let list = admins
        let admin = list[adminIndex]
        let permissions = admin.permissions
        let permissionsObject = this.state.permissionsObject
        if (sectionKey == 'fields') {
            if (permissions == '*') {
                permissions = {}
                for (const [skey, svalue] of Object.entries(permissionsObject)) {
                    permissions[skey] = '*'
                }
                permissions[sectionKey] = '*'
            }
            else {
                permissions[sectionKey] = '*'
            }
            if (permissions == null) {
                permissions = {}
            }
            if (permissions[sectionKey] == '*') {
                permissions[sectionKey] = {}
                permissions[sectionKey][permissionKey] = '*'
                permissions[sectionKey][permissionKey] = '*'
            }
            if (permissions[sectionKey] && permissions[sectionKey][permissionKey] == '*') {
                permissions[sectionKey][permissionKey] = {}
                permissions[sectionKey][permissionKey].view = true
                permissions[sectionKey][permissionKey].edit = true
            }
            delete permissions[sectionKey][permissionKey][subpermission]
            if (permissions[sectionKey][permissionKey]?.length == 2) {
                permissions[sectionKey][permissionKey] = '*'
            }
            let fullAccess = true
            Object.values(permissions).forEach((element) => {
                if (element != '*') {
                    fullAccess = false
                }
            })
            list[this.state.currentItemIndex].permissions = permissions
            admins = list
            this.setState({ admins })
        }
        else {
            if (permissions == '*') {
                permissions = {}
                for (const [skey, svalue] of Object.entries(permissionsObject)) {
                    permissions[skey] = '*'
                }
                permissions.fields = admin.permissions.fields ?? '*'
            }
            if (permissions == null) {
                permissions = {}
            }
            if (permissions[sectionKey] == '*') {
                permissions[sectionKey] = {}
                Object.values(permissionsObject[sectionKey].permissions).forEach((element) => {
                    if (element.subPermissions) {
                        permissions[sectionKey][element.key] = '*'
                    }
                    else {
                        permissions[sectionKey][element.key] = true
                    }
                })
                if (permissions[sectionKey] && permissions[sectionKey][permissionKey]) {
                    if (!admin.exception && permissionKey == 'view') {
                        delete permissions[sectionKey].edit
                    }
                    delete permissions[sectionKey][permissionKey]
                }
            }
            if (permissions[sectionKey] && permissions[sectionKey][permissionKey] == '*') {
                permissions[sectionKey][permissionKey] = {}
                for (let i = 0; i < Object.keys(permissionsObject[sectionKey].permissions[permissionKey].subPermissions).length; i++) {
                    permissions[sectionKey][permissionKey][Object.keys(permissionsObject[sectionKey].permissions[permissionKey].subPermissions)[i]] = true
                }
            }
            if (permissions[sectionKey] && permissions[sectionKey][permissionKey] && permissions[sectionKey][permissionKey][subpermission]) {
                if (!admin.exception && subpermission == 'view') {
                    delete permissions[sectionKey][permissionKey].create
                    delete permissions[sectionKey][permissionKey].delete
                    delete permissions[sectionKey][permissionKey].edit
                }
                delete permissions[sectionKey][permissionKey][subpermission]
            }
            else {
                if (!admin.exception && subpermission != 'view') {
                    if (!permissions[sectionKey]) {
                        permissions[sectionKey] = {}
                    }
                    if (!permissions[sectionKey][permissionKey]) {
                        permissions[sectionKey][permissionKey] = {}
                    }
                    permissions[sectionKey][permissionKey].view = true
                }
                if (!permissions[sectionKey]) {
                    permissions[sectionKey] = {}
                }
                if (!permissions[sectionKey][permissionKey]) {
                    permissions[sectionKey][permissionKey] = {}
                }
                permissions[sectionKey][permissionKey][subpermission] = true
            }
            if (Object.values(permissionsObject[sectionKey].permissions[permissionKey]?.subPermissions)?.length == Object.values(permissions[sectionKey][permissionKey])?.length) {
                permissions[sectionKey][permissionKey] = '*'
            }
            let fullAccess = true
            Object.values(permissions).forEach((element) => {
                if (element != '*') {
                    fullAccess = false
                }
            })
            if ((Object.values(permissions).length == Object.values(this.state.permissionsObject).length && fullAccess)) {
                permissions = '*'
            }
            list[this.state.currentItemIndex].permissions = permissions
            admins = list
            this.setState({ admins })
        }
    }

    setSearchTab = (tab) => {
        this.setState({ searchTab: tab })
    }

    changeSearchValue = (event) => {
        this.setState({ search: event.target.value }, () => {

        })
    }

    openFixedView = (tab) => {
        let groups = []
        let hubs = []
        this.state.admins.forEach(admin => {
            if (admin?.group)
                groups.push(admin?.group)
            if (admin?.hub)
                hubs.push(admin?.hub)

        });
        this.setState({ hubsInitData: hubs, groupsInitData: groups })
        if (tab == 'users') {
            setTimeout(() => {
                this.searchUsersFixedView.showView()
            }, 50);
        }
        if (tab == 'groups') {
            setTimeout(() => {
                this.searchGroupsFixedView.showView()
            }, 50);
        }
    }


    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static'
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }
    topHeaderComponent = () => {
        return (
            <div className='flexc'>

                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.nextStage}
                    title={translate("ca.Continue")}
                    icon='/assets/icons/angle-right-white2.svg'
                    textColor={'#222'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />

            </div>

        )
    }
    render() {
        let variables = this.props.variables
        if (!variables) {
            variables = {}
        }
        let hub = this.props.initData?.hub
        variables.hub = hub
        variables.targetId = hub
        let searchTab = this.state.searchTab
        return (
            // <div className='h-100 w-100 scroll-no-scrollbar'>
            //     <div className='w-100 h-100 scroll-no-scrollbar' style={{ position: 'relative', top: 0 }}>
            //         <CAHeader ref={el => this.header = el} config={this.state?.headerConfig} toolbar={this.state?.toolbar} showToolbar={this.state?.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state?.page} language={this.props.language} toolbarView={'applet'} headertype={'applet'} headers={this.state?.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state?.sections} modules={this.state?.modules} changePage={this.changePage} backbtn={this.state?.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} features={this.props.applet?.features} />
            //     </div>

            <div className='h-100 '>
                <div className='w-100 h-100 position-absolute overflow-hidden' >
                    <div style={{ height: 1500, width: 1500, zIndex: 0, position: 'absolute', top: -50, left: -50, background: 'radial-gradient(67.22% 50% at 50% 50%, rgba(51, 231, 255, 0.15) 0%, rgba(245, 228, 255, 0) 100%)' }}>
                    </div>
                    <div style={{ height: 1500, width: 1500, zIndex: 0, position: 'absolute', top: -100, left: "50%", background: 'radial-gradient(48.02% 35.72% at 50% 50%, rgba(50, 247, 51, 0.15) 0%, rgba(128, 255, 0, 0) 100%)' }}>
                    </div>
                </div>
                <div className='w-100' style={{ position: 'relative', top: 0 }}>
                    <CAHeader ref={el => this.header = el} config={this.state?.headerConfig} toolbar={this.state?.toolbar} showToolbar={this.state?.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state?.page} language={this.props.language} toolbarView={'applet'} headertype={'applet'} headers={this.state?.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state?.sections} modules={this.state?.modules} changePage={this.changePage} backbtn={this.state?.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} features={this.props.applet?.features} />
                </div>
                <div className=" w-100 h-100 scroll-no-scrollbar pt-3 position-relative  flex-column" style={{ backgroundColor: '' }}>
                    <div className=' w-100 '>
                        <Responsive width={this.props.width} media={{ xs: "12", md: '12' }}>
                            <div className='px-3 flexcc flex-column'>
                                <div className='w-100' style={{ maxWidth: 650 }}>
                                    <div >
                                        <p className="mt-1 text-small color-dark-blue-1 " >{translate('ca.Who can have access to this applet? Admin access and users access')}</p>
                                    </div>
                                    <div className='mt-3 postition-relative'>
                                        {this.state.filterApplet[this.props.initData.features[0]] && (
                                            <>
                                                <div className='pb-1 mb-1 flexcc'>
                                                    <div className='' style={{ width: 250 }}>
                                                        <div className='flexcb permission-btn br-20 p-1' style={{}}>
                                                            <button onClick={() => this.setSearchTab('users')} className={' mrd-2 br-20 w-50 ' + (searchTab == 'users' ? ' permission-select-btn ' : ' permission-notselect-btn ')}>
                                                                <p className={"px-3 py-2 flexcc weight-600 text-small "}>Users</p>
                                                            </button>
                                                            <button onClick={() => this.setSearchTab('groups')} className={' mld-2 br-20 w-50 ' + (searchTab == 'groups' ? ' permission-select-btn ' : ' permission-notselect-btn ')}>
                                                                <p className={"px-3 py-2 flexcc weight-600 text-small "}>Groups</p>
                                                            </button>
                                                        </div>
                                                        <div className='navbarSearch3 my-2 w-100 py-2 px-3 br-100' ref={searchTab == 'users' ? (ref => this.searchUsersNode = ref) : (ref => this.searchGroupsNode = ref)} >
                                                            <div className='d-flex flexcb' onClick={() => { this.openFixedView(searchTab) }} >
                                                                <input className="w-100" onChange={e => this.changeSearchValue(e)} value={this.state.search} type="text" placeholder={translate(`Search in ${searchTab}`)} style={{ backgroundColor: 'transparent', }} />
                                                                <img className='' width={25} src="/assets/icons/search-gray.svg" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="mt-1 mb-3 w-100 bg-white pt-1" style={{ borderRadius: 4 }} >
                                                    {this.state.admins?.map((item, index) => {
                                                        return (
                                                            <div className={'w-100 task-row' + (item.done ? ' done ' : '')} key={index}>
                                                                <div className='flexcb w-100 py-2  mb-1 ' style={{ borderBottom: '1px solid #EFF0F1' }}>
                                                                    <div className='flexc '>
                                                                        <ActionButton>
                                                                            <div className=" mt-2 mld-3 py-3 px-3 d-flex flex-column w-100" style={{ minWidth: 120, boxShadow: '0px 0px 30px #10101030', backgroundColor: '#fff', borderRadius: 6 }}>
                                                                                <button onClick={() => this.openPermissions(item, index)} className="w-100 p-0 text-start flexcb mt-1" >
                                                                                    <p className="text-small  ">{translate('ca.Edit')}</p>
                                                                                    <img src='/assets/icons/useful/text.svg' height={15} />
                                                                                </button>
                                                                                {(!item.mainAccess && item.type != 'byAppletAccess') && (
                                                                                    <button onClick={() => this.removePermission(item, index)} className="w-100 p-0 mt-1 text-start flexcb" >
                                                                                        <p className="text-small ">{translate('ca.Remove')}</p>
                                                                                        <img src='/assets/icons/useful/trash-o.svg' height={15} />
                                                                                    </button>
                                                                                )}
                                                                            </div>
                                                                        </ActionButton>
                                                                        <div onClick={() => this.openPermissions(item, index)} className='flexc task-info w-100 cursor-pointer flex-wrap'>
                                                                            {item?.hub &&
                                                                                this.infoView(item?.hub)
                                                                            }
                                                                            {item?.group &&
                                                                                this.infoView(item?.group)
                                                                            }
                                                                            {((!item?.hub) && item?.type != 'byAppletAccess') && (!item?.group) && (
                                                                                <div>
                                                                                    <p className='color-gray-2 text-small px-2'>{translate('ca.No access is added. This permission will be removed')}</p>
                                                                                </div>
                                                                            )}
                                                                            {item?.type == 'byAppletAccess' && (
                                                                                <div>
                                                                                    <p className='color-gray-2 text-small px-2'>{translate('ca.Global Access')}</p>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <div className='flexc'>
                                                                        <div onClick={() => this.openPermissions(item, index)} className='cursor-pointer mx-2'>
                                                                            <div className='py-1 px-2  task-priority' style={{ backgroundColor: item.permissions == '*' ? '#FEE9EE' : "#eee", color: item.permissions == '*' ? '#CA5C72' : '#777', borderRadius: 4 }}>
                                                                                <p className=' text-smallest no-wrap'>{checkTranslation(this.showPermissionsText(item.permissions))}</p>
                                                                            </div>
                                                                        </div>
                                                                        <button className='flexcc mld-2' onClick={() => this.openPermissions(item, index)}>
                                                                            <img src='/assets/icons/shield.svg' className='flexcc opacity-5' width={28} />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </>
                                        )}
                                    </div >
                                </div >
                            </div >
                        </Responsive >
                    </div >
                </div >
                <FixedView width={this.props.width} zIndex={10} ref={el => this.searchUsersFixedView = el} nodeRef={this.searchUsersNode} xOffset={this.props.language == 'fa' ? 195 : -10} topOffset={0} maxWidth={250} >
                    <SearchUsersFixedView actions={this.props.actions} hubsInitData={this.state.hubsInitData} data={this.state.search} mainAccess={this.state.isMainAccess} onDone={this.onNewUsersSelected} variables={variables} language={this.props.language} />
                </FixedView>
                <FixedView width={this.props.width} zIndex={10} ref={el => this.searchGroupsFixedView = el} nodeRef={this.searchGroupsNode} xOffset={this.props.language == 'fa' ? 195 : -10} topOffset={0} maxWidth={250} >
                    <SearchGroupsFixedView actions={this.props.actions} groupsInitData={this.state.groupsInitData} mainAccess={this.state.isMainAccess} ref={el => this.searchGroupsModal = el} onDone={this.onNewUsersSelected} variables={variables} language={this.props.language} />
                </FixedView>
                <SidebarView width={this.props.width} ref={el => this.sidebarView = el} hideOverlay={false} widthCondition={{ xs: '80%', md: '300px' }}>
                    {(this.state.currentItemIndex != null) && (
                        <div className='px-2 pt-3 h-100 scroll-no-scrollbar pb-5'>
                            <div className='flexcb px-2 '>
                                <p className='text-semibold mb-1'>{translate("ca.Admin Access")}</p>
                            </div>
                            <div className='mt-2 d-flex flex-column flex-wrap'>
                                {this.state.currentItemIndex != null && this.state.admins && this.state.admins[this.state.currentItemIndex]?.hub &&
                                    this.permissionInfoView(this.state.admins[this.state.currentItemIndex]?.hub, 'hubs')
                                }
                                {this.state.currentItemIndex != null && this.state.admins && this.state.admins[this.state.currentItemIndex]?.group &&
                                    this.permissionInfoView(this.state.admins[this.state.currentItemIndex]?.group, 'groups')
                                }
                            </div>
                            <div className='mt-3 px-2'>
                                <p className='text-semibold mb-1'>{translate("ca.Permissions")}</p>
                                {this.state.permissionsObject && Object.values(this.state.permissionsObject).map((sectionPermission, index) => {
                                    return (
                                        <div>
                                            <div>
                                                <p>{checkTranslation(sectionPermission.label)}</p>
                                            </div>
                                            {Object.values(sectionPermission.permissions).map((permission) => {
                                                let hasPermission = false
                                                let thisPermission = this.state.admins[this.state.currentItemIndex]?.permissions
                                                if (thisPermission == '*') {
                                                    hasPermission = true
                                                }
                                                if (thisPermission && typeof thisPermission[sectionPermission.key] == 'object') {
                                                    hasPermission = thisPermission[sectionPermission.key][permission.key]
                                                }
                                                return (
                                                    <div className='flexcb pt-2 pb-2 px-2 ' style={{ borderBottom: '1px solid #f6f6f6' }}>
                                                        {permission.subPermissions ?
                                                            (<>
                                                                <div className='w-100'>
                                                                    <p>{checkTranslation(permission.label)}</p>
                                                                    {Object.values(permission.subPermissions).map((element) => {
                                                                        hasPermission = false
                                                                        if (thisPermission == '*') {
                                                                            hasPermission = true
                                                                        }
                                                                        else if (thisPermission && thisPermission[sectionPermission.key] == '*') {
                                                                            hasPermission = true
                                                                        }
                                                                        else {
                                                                            hasPermission = ((thisPermission && thisPermission[sectionPermission.key] && thisPermission[sectionPermission.key][permission.key] && thisPermission[sectionPermission.key][permission.key][element.key])
                                                                                || (thisPermission && thisPermission[sectionPermission.key] && thisPermission[sectionPermission.key][permission.key] == '*')) ? true : false
                                                                        }
                                                                        return (
                                                                            <div className='flexcb pld-2'>
                                                                                <p>{checkTranslation(element.title)}</p>
                                                                                <input type={'checkbox'} checked={hasPermission} onChange={() => this.handleCheckBox(sectionPermission.key, permission.key, element.key, this.state.currentItemIndex)} />
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </div>
                                                            </>
                                                            ) : (
                                                                <>
                                                                    <p className='text-small color-gray-1'>{checkTranslation(permission.label)}</p>
                                                                    <SwitchInput data={hasPermission} header={{ key: permission.key, information: { size: 'small', } }} changeValue={this.changePermission} extra={{ type: 'admin', index: this.state.currentItemIndex, sectionKey: sectionPermission.key }} />
                                                                </>
                                                            )
                                                        }
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    )
                                })}
                            </div>
                        </div >
                    )}
                </SidebarView>
                {/* <SidebarView width={this.props.width} ref={el => this.editFieldsSidebarView = el} hideOverlay={false} widthCondition={{ xs: '80%', md: '300px' }}>
                    <div className='py-3 pld-3'>
                        <div className='flexc' style={{ justifyContent: 'end' }}>
                            <p>view</p>
                            <p>edit</p>
                        </div>
                        {this.state.fields?.map((element, eIndex) => {
                            let hasPermission = false
                            let thisPermission = (this.state.admins.collection[this.state.currentCollection] && this.state.admins.collection[this.state.currentCollection][this.state.currentItemIndex]?.permissions) ? this.state.admins.collection[this.state.currentCollection][this.state.currentItemIndex]?.permissions : '*'
                            if (thisPermission == '*') {
                                hasPermission = true
                            }
                            if (thisPermission == '*') {
                                hasPermission = true
                            }
                            else if (thisPermission && thisPermission[element.id] == '*') {
                                hasPermission = true
                            }
                            else {
                                hasPermission = thisPermission[element.id]
                            }
                            return (
                                <div className='flexcb'>
                                    <p>
                                        {checkTranslation(element.information.label)}
                                    </p>
                                    <div style={{ flexDirection: 'column' }} className='flexcc pr-2'>
                                        <div className='flexcc'>
                                            <input type={'checkbox'} checked={typeof hasPermission == 'object' ? hasPermission.view : hasPermission} onChange={() => this.handleCheckBox('fields', element.id, 'view', this.state.currentItemIndex)} />
                                            <input type={'checkbox'} checked={typeof hasPermission == 'object' ? hasPermission.edit : hasPermission} onChange={() => this.handleCheckBox('fields', element.id, 'edit', this.state.currentItemIndex)} />
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </SidebarView> */}
            </div >
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CAPermissions);